module.exports = __webpack_public_path__ + "static/media/S.5e0c4f3f.jpg";